import * as types from './types';
export function getPatient(patientId, token) {
    return {
        type: types.GET_PATIENT_DETAILS,
        patientId,
        token,
    };
}

export function patientDetailResponse(response) {
    return {
        type: types.PATIENT_DETAILS_RESPONSE,
        response,
    };
}
export function getPatientDetailFailed(response) {
    return {
        type: types.GET_PATIENT_DETAILS_FAILED,
        response,
    };
}
export function validClient(payload, token) {
    return {
        type: types.VALID_CLIENT_REQUEST,
        payload,
        token,
    };
}

export function validationFailed() {
    return {
        type: types.VALID_CLIENT_FAILED,
    };
}

export function onValidClientResponse(response) {
    return {
        type: types.VALID_CLIENT_RESPONSE,
        response,
    };
}
export function onClearDataSuccess() {
    return {
        type: types.CLEAR_DATA_RESPONSE,
    };
}
export function getChildren(params, token) {
    return {
        type: types.GET_CHILDREN_REQUEST,
        params,
        token,
    };
}

export function onGetChildrenResponse(response) {
    return {
        type: types.GET_CHILDREN_RESPONSE,
        response,
    };
}
export function onGetChildrenFailed(response) {
    return {
        type: types.GET_CHILDREN_FAILED,
        response,
    };
}
// Add children
export function addChildren(payload, token) {
    return {
        type: types.ADD_CHILDREN_REQUEST,
        payload,
        token,
    };
}

export function onAddChildrenResponse(response) {
    return {
        type: types.ADD_CHILDREN_RESPONSE,
        response,
    };
}
export function onAddChildrenFailed(response) {
    return {
        type: types.ADD_CHILDREN_FAILED,
        response,
    };
}
// Add family member
export function addFamilyMember(payload, token) {
    return {
        type: types.ADD_FAMILY_MEMBER_REQUEST,
        payload,
        token,
    };
}

export function onAddFamilyMemberResponse(response) {
    return {
        type: types.ADD_FAMILY_MEMBER_RESPONSE,
        response,
    };
}

//ADD USER DETAILS
export function addUserConsentsDetails(payload, token) {
    return {
        type: types.ADD_USER_DETAILS_REQUEST,
        payload,
        token
    }
}
export function addUserConsentsDetailsResponse(response) {
    return {
        type: types.ADD_USER_DETAILS_RESPONSE,
        response
    }
}
export function addUserConsentsDetailsFailed(response) {
    return {
        type: types.ADD_USER_DETAILS_FAILED,
        response
    }
}
export function checkUserConsentsDetails(payload, token) {
    return {
        type: types.GET_CHECK_USER_DETAILS_SIGNED,
        payload,
        token
    }
}
export function checkUserConsentsDetailsResponse(response) {
    return {
        type: types.GET_CHECK_USER_DETAILS_SIGNED_RESPONSE,
        response
    }
}
//Get Doc
export function getDocFromAlias(payload, token) {
    return {
        type: types.GET_DOC_REQUEST,
        payload,
        token,
    };
}

export function getDocFailed() {
    return {
        type: types.GET_DOC_FAILED,
    };
}

export function onGetDocFromAliasResponse(response) {
    return {
        type: types.GET_DOC_RESPONSE,
        response,
    };
}
//Get Room Token
export function getOpentokRoomKeys(payload, token) {
    return {
        type: types.GET_ROOM_KEYS_REQUEST,
        payload,
        token,
    };
}

export function getRoomKeysFailed() {
    return {
        type: types.GET_ROOM_KEYS_FAILED,
    };
}

export function onGetRoomKeysResponse(response) {
    return {
        type: types.GET_ROOM_KEYS_RESPONSE,
        response,
    };
}
//Generate CallID
export function generateCallIdByPatientId(payload, token) {
    return {
        type: types.GENERATE_CALLID_REQUEST,
        payload,
        token,
    };
}

export function generateCallIDFailed() {
    return {
        type: types.GENERATE_CALLID_FAILED,
    };
}

export function onGenerateCallIDResponse(response) {
    return {
        type: types.GENERATE_CALLID_RESPONSE,
        response,
    };
}
//Add user to waiting
export function addUserToWaitingRoom(payload, token) {
    return {
        type: types.ADD_USER_TO_WAITING_REQUEST,
        payload,
        token,
    };
}

export function addUserToWaitingFailed() {
    return {
        type: types.ADD_USER_TO_WAITING_FAILED,
    };
}

export function onAddUserToWaitingResponse(response) {
    return {
        type: types.ADD_USER_TO_WAITING_RESPONSE,
        response,
    };
}
//Notify Provider
export function notifyProvider(payload, token) {
    return {
        type: types.NOTIFY_PROVIDER_REQUEST,
        payload,
        token,
    };
}

export function notifyProviderFailed() {
    return {
        type: types.NOTIFY_PROVIDER_FAILED,
    };
}

export function onNotifyProviderResponse(response) {
    return {
        type: types.NOTIFY_PROVIDER_RESPONSE,
        response,
    };
}
//Check Room Status
export function checkRoomStatus(payload, token) {
    return {
        type: types.CHECK_ROOM_STATUS_REQUEST,
        payload,
        token,
    };
}

export function checkRoomStatusFailed() {
    return {
        type: types.CHECK_ROOM_STATUS_FAILED,
    };
}

export function onCheckRoomStatusResponse(response) {
    return {
        type: types.CHECK_ROOM_STATUS_RESPONSE,
        response,
    };
}

// Call End
export function callEndByPatient(payload, token) {
    return {
        type: types.CALL_END_BY_PATIENT_REQUEST,
        payload,
        token,
    };
}

// Update Room Status
export function updateRoomStatus(payload, token) {
    return {
        type: types.UPDATE_ROOM_STATUS,
        payload,
        token,
    };
}

export function onUpdateRoomStatusResponse(response) {
    return {
        type: types.UPDATE_ROOM_STATUS_SUCCESS,
        response,
    };
}
// to store selected children data

export function onAddSelectedChild(payload) {
    return {
        type: types.ADD_SELECTED_CHILD,
        payload
    }
}
export function onRemoveSelectedChild(response) {
    return {
        type: types.REMOVE_SELECTED_CHILD,
        response
    }
}
// search medication and allergy
export function searchMedication(query, token) {
    return {
        type: types.MEDICATION_SEARCH,
        query,
        token,
    };
}

export function onSearchMedication(response) {
    return {
        type: types.MEDICATION_SEARCH_SUCCESS,
        response,
    };
}

export function searchAllergy(query, token) {
    return {
        type: types.ALLERGY_SEARCH,
        query,
        token,
    };
}

export function onSearchAllergy(response) {
    return {
        type: types.ALLERGY_SEARCH_SUCCESS,
        response,
    };
}
// STORE medications and allergies
export function storeMedication(response) {
    return {
        type: types.MEDICATION_STORED,
        response
    };
}

export function storeAllergy(response) {
    return {
        type: types.ALLERGIES_STORED,
        response
    };
}
export function storeMedicalCondition(response) {
    return {
        type: types.MEDICAL_CONDITION_STORED,
        response
    };
}
export function storeSymptoms(response) {
    return {
        type: types.SYMPTOMS_STORED,
        response
    };
}

//upload medication
export function uploadMedications(payload, gender, token, userType, room) {
    return {
        type: types.UPLOAD_MEDICATIONS,
        payload,
        gender,
        token,
        userType,
        room
    };
}

export function uploadMedicationsSuccess(response) {
    return {
        type: types.UPLOAD_MEDICATIONS_SUCCESS,
        response,
    };
}

// Disconnect Reason
export function disconnectReason(payload, token) {
    return {
        type: types.DISCONNECT_REASON_REQUEST,
        payload,
        token,
    };
}
export function providerSettings(payload, token) {
    return {
        type: types.PROVIDER_SETTINGS_REQUEST,
        payload,
        token,
    };
}
export function invalidateRequest(payload, token) {
    return {
        type: types.INVALIDATE_REQUEST,
        payload,
        token,
    };
}
export function clearRoomStatus() {
    return {
        type: types.CLEAR_ROOM_STATUS,
    };
}
export function clearDataRequest() {
    return {
        type: types.CLEAR_DATA_REQUEST,
    };
}

export function resetPatientData() {
    return {
        type: types.RESET_PATIENT_DATA
    }
}
export function enableLoader() {
    return {
        type: types.ENABLE_LOADER,
    };
}

export function disableLoader() {
    return {
        type: types.DISABLE_LOADER,
    };
}